import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

import "../styles/Navbar.scss";

import BrandImage from "./BrandImage";

import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

const navItems = [
  { id: 2, name: "Clients", path: "/#clients" },
  { id: 0, name: "Offer", path: "/#offer" },
  { id: 1, name: "About", path: "/#about" },
];

function Navbar() {
  const [menuClick, setMenuClick] = useState(false);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  const handleMenuClick = () => {
    setMenuClick(!menuClick);
  };

  return (
    <nav>
      <BrandImage />
      <ul className={menuClick ? "showUl" : "no"}>
        {navItems.map((navItem) => (
          <li key={navItem.id}>
            <Link
              smooth
              to={navItem.path}
              scroll={(el) => scrollWithOffset(el)}
              onClick={handleMenuClick}
            >
              {navItem.name}
            </Link>
          </li>
        ))}
      </ul>
      {menuClick ? (
        <CloseIcon
          onClick={handleMenuClick}
          className="menuIcon"
          style={{ fill: "white" }}
        />
      ) : (
        <MenuIcon onClick={handleMenuClick} className="menuIcon" />
      )}
      <Link
        smooth
        to="/#contact"
        className="contactBtn"
        scroll={(el) => scrollWithOffset(el)}
      >
        Get in Touch
      </Link>
    </nav>
  );
}

export default Navbar;
